<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const NewGamesIcon = getIcon("NewGamesIcon");
</script>

{#if typeof NewGamesIcon === 'string'}
	<img src={NewGamesIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof NewGamesIcon === 'function'}
	<svelte:component this={NewGamesIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
